import React from 'react';
import { ProfitMaximizerUpsell } from '../components/ProfitMaximizerUpsell';
export function Modulo4Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1942">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1943">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1944">
          AI <span className="text-[#F5C842]" data-id="element-1945">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1946">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1947">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1948">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1949">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1950">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1951">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1952">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-1953">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1954">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1955">
            Módulo 4 de 4 — Final
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1956">
            ⏱ 15 minutos · El Guion de Cierre Completo
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1957">
          El Cierre
          <br data-id="element-1958" />
          <span className="text-[#F5C842]" data-id="element-1959">Sin Presión</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1960">
          El guion exacto para convertir una conversación casual en una venta de
          $350. No es una venta — es una conversación. Y tienes algo que ellos
          quieren.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1961">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1962">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1963"></div>
            Guion de apertura + seguimiento
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1964">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1965"></div>
            Las 5 objeciones y cómo responderlas
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1966">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1967"></div>
            Estrategia de precios y plan de pagos
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1968">
        {/* MINDSET BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-7 py-6" data-id="element-1969">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1970">
            &#x1F4A1; El Cambio de Mentalidad que lo Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1971">
            Sé que para muchos esta es la parte más intimidante. Llamar a un
            extraño y ofrecerle algo. Pero cuando termines este módulo, vas a
            ver que{' '}
            <strong className="text-white" data-id="element-1972">
              no es una venta. Es una conversación.
            </strong>{' '}
            Y tienes algo que ellos quieren — su negocio representado de forma
            profesional en internet.
          </div>
        </div>

        {/* SCRIPT CARDS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1973">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1974"></span>
          El Guion de Cierre — Copiar y Pegar
        </div>

        {/* PASO 1 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1975">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1976">
            <span className="text-[18px]" data-id="element-1977">📱</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1978">
              PASO 1 — Apertura (WhatsApp o llamada)
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1979">
              ⏱ Primer contacto
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1980">
            "Hola, ¿hablo con{' '}
            <span className="italic text-[#666]" data-id="element-1981">[Nombre del dueño]</span>? Mi
            nombre es <span className="italic text-[#666]" data-id="element-1982">[Tu nombre]</span>.
            Vi su negocio{' '}
            <span className="italic text-[#666]" data-id="element-1983">[Nombre del negocio]</span> en
            Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
            preparé una demo de cómo podría verse. ¿Le puedo enviar el link para
            que lo vea?"
            <br data-id="element-1984" />
            <br data-id="element-1985" />
            <span className="not-italic font-bold text-white" data-id="element-1986">
              — Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link.
            </span>
            <br data-id="element-1987" />
            <span className="not-italic font-bold text-white" data-id="element-1988">
              — La mayoría dirá que sí porque es gratis y no les pides nada.
            </span>
          </div>
        </div>

        {/* PASO 2 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1989">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1990">
            <span className="text-[18px]" data-id="element-1991">⏳</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1992">
              PASO 2 — Envía la demo y espera
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1993">
              ⏱ Inmediatamente después
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1994">
            Cuando digan que sí,{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-1995">
              envía el link de la demo
            </span>{' '}
            que construiste en el Módulo 3.
            <br data-id="element-1996" />
            <br data-id="element-1997" />
            <span className="not-italic font-bold text-white" data-id="element-1998">
              Espera exactamente 10 minutos.
            </span>
            <br data-id="element-1999" />
            <br data-id="element-2000" />
            No escribas antes. No preguntes si la vieron. Espera los 10 minutos
            y luego envía el seguimiento.
          </div>
        </div>

        {/* PASO 3 */}
        <div className="mb-8 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-2001">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-2002">
            <span className="text-[18px]" data-id="element-2003">💰</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-2004">
              PASO 3 — Seguimiento y cierre
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-2005">
              ⏱ 10 minutos después de enviar la demo
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-2006">
            "¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo y
            publicado en{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-2007">
              48 horas por $350
            </span>
            . Incluye el dominio y el primer mes de hosting."
            <br data-id="element-2008" />
            <br data-id="element-2009" />
            <span className="not-italic font-bold text-white" data-id="element-2010">
              Si dicen que sí → cobras.
            </span>
            <br data-id="element-2011" />
            <span className="not-italic font-bold text-white" data-id="element-2012">
              Si dicen que es caro → ofrece plan de pagos: $175 ahora, $175 en
              30 días.
            </span>
            <br data-id="element-2013" />
            <span className="not-italic font-bold text-white" data-id="element-2014">
              Si siguen sin cerrar → pasa al siguiente prospecto. No negocies
              demasiado. Tu tiempo vale.
            </span>
          </div>
        </div>

        {/* PRICING */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2015">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2016"></span>
          Estructura de Precios
        </div>
        <div className="mb-8 grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-2017">
          <div className="rounded-lg border border-[#F5C842] bg-[#0d0d0d] p-5 text-center" data-id="element-2018">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2019">
              Precio Estándar
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-[#F5C842]" data-id="element-2020">
              $350
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2021">
              Sitio web completo + dominio + primer mes de hosting. Pago único
              al cerrar.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-2022">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-2023">
              Plan de Pagos
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-2024">
              2x$175
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2025">
              $175 al cerrar + $175 a los 30 días. Para clientes que dicen "es
              caro".
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-2026">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-2027">
              Mantenimiento Mensual
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-2028">
              $99/mes
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2029">
              Hosting, actualizaciones y soporte. Ofrécelo después de entregar
              el sitio.
            </div>
          </div>
        </div>

        {/* OBJECTIONS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2030">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2031"></span>
          Las 5 Objeciones Más Comunes y Cómo Responderlas
        </div>
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-3.5" data-id="element-2032">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2033">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2034">
              ❌ "Es muy caro."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2035">
              <span className="font-bold text-[#4caf50]" data-id="element-2036">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Cuánto le cuesta perder un cliente porque no lo
              encontraron en Google?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2037">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2038">
              ❌ "Ya tengo uno."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2039">
              <span className="font-bold text-[#4caf50]" data-id="element-2040">✅ Tu respuesta:</span>{' '}
              "¿Puedo verlo? [Pausa] Entiendo. ¿Le gustaría uno que realmente
              traiga clientes?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2041">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2042">
              ❌ "Déjame pensarlo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2043">
              <span className="font-bold text-[#4caf50]" data-id="element-2044">✅ Tu respuesta:</span>{' '}
              "Por supuesto. ¿Cuándo podría hablar con usted de nuevo? ¿Mañana a
              las 10?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2045">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2046">
              ❌ "No tengo tiempo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2047">
              <span className="font-bold text-[#4caf50]" data-id="element-2048">✅ Tu respuesta:</span>{' '}
              "No se preocupe, yo me encargo de todo. Usted solo me aprueba el
              diseño."
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111] md:col-span-2" data-id="element-2049">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2050">
              ❌ "No sé si lo necesito."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2051">
              <span className="font-bold text-[#4caf50]" data-id="element-2052">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Sabe cuántas personas buscan{' '}
              <span className="text-[#F5C842]" data-id="element-2053">[tipo de negocio]</span> en
              Google en su ciudad cada mes? Sin sitio web, ninguna de ellas lo
              encuentra a usted."
            </div>
          </div>
        </div>

        {/* FULL SCRIPT */}
        <div className="mb-8" data-id="element-2054">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2055">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2056"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-2057">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2058">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2059"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2060">
              "Módulo 4. El cierre. Sé que para muchos esta es la parte más
              intimidante. Llamar a un extraño y ofrecerle algo. Pero te prometo
              que cuando termines este módulo, vas a ver que no es una venta. Es
              una conversación. Y tienes algo que ellos quieren."
            </div>
          </div>

          <div className="mb-4" data-id="element-2061">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2062">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2063"></span>⏱
              0:30 – 10:00 · El Guion de Cierre
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2064">
              "Voy a darte el guion exacto. Puedes leerlo las primeras veces si
              necesitas. Con el tiempo, será natural."
              <br data-id="element-2065" />
              <br data-id="element-2066" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-2067">
                APERTURA (WhatsApp o llamada):
              </span>
              <br data-id="element-2068" />
              "'Hola, ¿hablo con{' '}
              <span className="italic text-[#666]" data-id="element-2069">[Nombre del dueño]</span>? Mi
              nombre es <span className="italic text-[#666]" data-id="element-2070">[Tu nombre]</span>.
              Vi su negocio{' '}
              <span className="italic text-[#666]" data-id="element-2071">[Nombre del negocio]</span>{' '}
              en Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
              preparé una demo de cómo podría verse. ¿Le puedo enviar el link
              para que lo vea?'"
              <br data-id="element-2072" />
              <br data-id="element-2073" />
              "Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link."
              <br data-id="element-2074" />
              <br data-id="element-2075" />
              "Cuando digan que sí (y la mayoría dirá que sí porque es gratis y
              no les pides nada), envía el link de la demo y espera 10 minutos.
              Luego escribe:"
              <br data-id="element-2076" />
              <br data-id="element-2077" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-2078">
                SEGUIMIENTO:
              </span>
              <br data-id="element-2079" />
              "'¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo
              y publicado en 48 horas por $350. Incluye el dominio y el primer
              mes de hosting.'"
              <br data-id="element-2080" />
              <br data-id="element-2081" />
              "Si dicen que sí, cobras. Si dicen que es caro, tienes dos
              opciones: ofrecer un plan de pagos ($175 ahora, $175 en 30 días) o
              simplemente pasar al siguiente prospecto. No negocies demasiado.
              Tu tiempo vale."
            </div>
          </div>

          <div className="mb-4" data-id="element-2082">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2083">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2084"></span>⏱
              10:00 – 13:00 · Las 5 Objeciones
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2085">
              "Las 5 objeciones más comunes y cómo responderlas:"
              <br data-id="element-2086" />
              <br data-id="element-2087" />
              "1. 'Es muy caro.' → 'Entiendo. ¿Cuánto le cuesta perder un
              cliente porque no lo encontraron en Google?'"
              <br data-id="element-2088" />
              "2. 'Ya tengo uno.' → '¿Puedo verlo? [Pausa] Entiendo. ¿Le
              gustaría uno que realmente traiga clientes?'"
              <br data-id="element-2089" />
              "3. 'Déjame pensarlo.' → 'Por supuesto. ¿Cuándo podría hablar con
              usted de nuevo? ¿Mañana a las 10?'"
              <br data-id="element-2090" />
              "4. 'No tengo tiempo.' → 'No se preocupe, yo me encargo de todo.
              Usted solo me aprueba el diseño.'"
              <br data-id="element-2091" />
              "5. 'No sé si lo necesito.' → 'Entiendo. ¿Sabe cuántas personas
              buscan [tipo de negocio] en Google en su ciudad cada mes? Sin
              sitio web, ninguna de ellas lo encuentra a usted.'"
            </div>
          </div>

          <div className="mb-4" data-id="element-2092">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2093">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2094"></span>⏱
              13:00 – 15:00 · Cierre Final del Curso
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2095">
              "Eso es todo. Tienes el sistema completo. Ahora ve y contacta tus
              5 prospectos hoy. No mañana. Hoy. El dinero está ahí afuera
              esperándote. El único paso que falta eres tú."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-2096">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-2097">
            ✅ Tu Tarea Final — Módulo 4
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-2098">
            Contacta a tus{' '}
            <strong className="text-white" data-id="element-2099">5 prospectos hoy</strong>. No mañana.
            Hoy. Tu objetivo es cerrar al menos 1 venta esta semana.
            <div className="mt-3 flex flex-col gap-2" data-id="element-2100">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2101">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2102">
                  1
                </div>
                Envía el mensaje de apertura al Prospecto #1 (WhatsApp o
                llamada)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2103">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2104">
                  2
                </div>
                Cuando diga que sí, envía el link de su demo
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2105">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2106">
                  3
                </div>
                Espera 10 minutos y envía el seguimiento con el precio de $350
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2107">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2108">
                  4
                </div>
                Repite con los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2109">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2110">
                  5
                </div>
                <strong className="text-white" data-id="element-2111">
                  Objetivo: cerrar al menos 1 venta esta semana
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSING BANNER */}
        <div className="mb-8 rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-10 py-10 text-center" data-id="element-2112">
          <div className="mb-3 font-heading text-[28px] font-black leading-tight text-white" data-id="element-2113">
            Ahora Ve y<br data-id="element-2114" />
            <span className="text-[#F5C842]" data-id="element-2115">Cierra Tu Primer Cliente</span>
          </div>
          <div className="mx-auto max-w-[500px] text-[14px] leading-[1.7] text-[#777]" data-id="element-2116">
            Tienes el sistema completo. Los cerebros de IA. El guion. Las demos.
            El único paso que falta eres tú. El dinero está ahí afuera
            esperándote.
          </div>
        </div>

        {/* PROFIT MAXIMIZER UPSELL */}
        <ProfitMaximizerUpsell data-id="element-2117" />
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-2118">
        <a href="/modulo-3" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-2119">
          ← Módulo 3
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-2120">
          AI <span className="text-[#F5C842]" data-id="element-2121">WEB CLOSER</span>
        </div>
        <div className="rounded bg-[#4caf50] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase" data-id="element-2122">
          ✓ Curso Completado
        </div>
      </div>
    </div>;
}